<template>
<div>
    <Header title="订单详情" />
    <div v-if="dataSources.status === 'WAIT_BUYER_PAY'" class="type">
        <img :src="Images.icon_wallet" alt="">
        <div>
            <p>待付款</p>
            <span>剩余23小时59分自动关闭</span>
        </div>
    </div>
    <div v-if="dataSources.status === 'WAIT_SELLER_SEND_GOODS'" class="type">
        <img :src="Images.icon_transport" alt="">
        <div>
            <p>待发货</p>
            <span>宝贝正在加急出库中 请耐心等待～</span>
        </div>
    </div>
    <div v-if="dataSources.status === 'WAIT_BUYER_CONFIRM_GOODS'" class="type">
        <img :src="Images.icon_transport" alt="">
        <div>
            <p>待收货</p>
            <span>宝贝正在加急出库中 请耐心等待～</span>
        </div>
        <span @click="_onPressToLogisticsInfo">查看物流信息</span>
    </div>
    <div v-if="dataSources.status === 'TRADE_SUCCESS'" class="type">
        <img :src="Images.icon_finish" alt="">
        <div>
            <p>已完成</p>
        </div>
        <span @click="_onPressToLogisticsInfo">查看物流信息</span>
    </div>
    <div v-if="dataSources.status === 'TRADE_CLOSED'" class="type">
        <img :src="Images.icon_finish" alt="">
        <div>
            <p>交易关闭</p>
            <span>再逛逛，下一件一定是有缘分的宝贝～</span>
        </div>
    </div>
    <div v-if="dataSources.status === 'REFUND'" class="type">
        <img :src="Images.icon_refund" alt="">
        <div>
            <p>查看</p>
            <span>本单退款记录</span>
        </div>
        <img class="arrow" :src="Images.icon_arrow_right2" alt="">
    </div>
    <div class="address">
        <img :src="Images.icon_area" alt="">
        <div>
            <p>{{dataSources.user_name}}<span>{{dataSources.user_mobile}}</span></p>
            <span>{{dataSources.user_area+' '+dataSources.user_address}}</span>
        </div>
    </div>
    <div class="goods">
        <p>{{dataSources.company_name}}</p>
        <div v-for="(item, index) in dataSources.order_detail" :key="index">
            <img :src="item.goods_image" alt="">
            <div>
                <p class="title">{{item.goods_name}}</p>
                <p class="unit">规格:{{item.sku_field_name}}</p>
                <div class="price">
                    <p>{{item.point}} 积分</p>
                    <span>×{{item.qty}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div>
            <p>商品小计</p>
            <span>{{dataSources.total_point}} 积分</span>
        </div>
        <div>
            <p>快递费用</p>
            <span>¥{{dataSources.freight_amount}}</span>
        </div>
        <div>
            <p>费用合计</p>
            <span>{{dataSources.total_point}} 积分 + {{dataSources.freight_amount}}元运费</span>
        </div>
        <div v-if="dataSources.remarkA" class="textarea noline">
            <p>备注</p>
            <textarea rows="3" cols="20" readonly v-model="dataSources.remark"></textarea>
        </div>
    </div>
    <div class="card">
        <div>
            <p>订单信息：</p>
        </div>
        <div>
            <p>订单编号：</p>
            <span>{{dataSources.order_no}}</span>
        </div>
        <div>
            <p>下单时间：</p>
            <span>{{dataSources.create_time}}</span>
        </div>
        <div v-if="dataSources.status==='WAIT_SELLER_SEND_GOODS'||dataSources.status==='WAIT_BUYER_CONFIRM_GOODS'||dataSources.status==='TRADE_SUCCESS'">
            <p>付款时间：</p>
            <span>{{dataSources.pay_time}}</span>
        </div>
        <div v-if="dataSources.status==='WAIT_BUYER_CONFIRM_GOODS'||dataSources.status==='TRADE_SUCCESS'">
            <p>发货时间：</p>
            <span>{{dataSources.express_time}}</span>
        </div>
        <div class="noline" v-if="dataSources.status==='TRADE_SUCCESS'">
            <p>收货时间：</p>
            <span>{{dataSources.receive_time}}</span>
        </div>
    </div>
    <div class="footerBox"></div>
    <div class="footer">
        <div class="service">
            <img :src="Images.icon_service" alt="">
            <p>客服</p>
        </div>
        <div class="btnBox">
            <div class="btn btn2" v-if="dataSources.status==='WAIT_BUYER_CONFIRM_GOODS'" @click.stop="onPressReceive(dataSources)">确认收货</div>
        </div>
    </div>
    <van-popup v-model="showPay" position="bottom">
        <div class="popup-window">
            <div>
                <p class="title">请选择支付方式</p>
            </div>
            <div class="item" :class="payType==='alipay'&&'check'" @click="onPressPayType('alipay')">
                <img :src="Images.icon_alipay" alt="">
                <p>支付宝</p>
                <div>
                    <div></div>
                </div>
            </div>
            <div class="item" :class="payType==='wechat'&&'check'" @click="onPressPayType('wechat')">
                <img :src="Images.icon_wechat" alt="">
                <p>微信支付</p>
                <div>
                    <div></div>
                </div>
            </div>
            <div class="item" :class="payType==='2b'&&'check'" @click="onPressPayType('2b')">
                <img :src="Images.icon_small_change" alt="">
                <p>公对公转账</p>
                <div>
                    <div></div>
                </div>
            </div>
            <div class="btn" @click="onPressSbumit">支付</div>
        </div>
    </van-popup>
</div>
</template>

<script>
import Header from '@/components/Header'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
    },
    /** 数据区 */
    data() {
        return {
            id: this.$route.query.id,
            dataSources: {},
            payType: 'alipay',
            showPay: false,
        };
    },
    /** 挂载后 */
    mounted() {
        this.requestData();
    },
    /** 方法 */
    methods: {
        // -------------------------------------------------- request  --------------------------------------------------
        async requestData() {
            let url = this.API.point_shop_order_detail;
            let params = {
                order_no: this.id,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                //  status: [
                //     WAIT_BUYER_PAY：等待买家付款，
                //     WAIT_SELLER_SEND_GOODS：等待卖家发货
                //     WAIT_BUYER_CONFIRM_GOODS 等待买家确认收货， 
                //     TRADE_SUCCESS：买家已签收以及订单成功， 
                //     TRADE_CLOSED：交易关闭
                // ],
                if (result.data.is_refund && result.data.is_refund > 0) {
                    result.data.status = 'REFUND'
                }
                this.dataSources = result.data;
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- onPress  --------------------------------------------------
        // 点击跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },

        _onPressToLogisticsInfo() {
            this.Lockr.set('send_record', JSON.stringify(this.dataSources.send_record));
            this.onPressNav('logistics');
        },

        // 取消订单
        onPressCancelOrder(item) {
            this.$dialog.confirm({
                    title: '温馨提示',
                    message: '您的操作即将取消订单！',
                })
                .then(() => {
                    this.cancelOrder(item);
                })
                .catch((error) => {
                    console.log('error---->', error);
                });
        },
        // 取消
        async cancelOrder(item) {
            let url = this.API.point_shop_cancel_order;
            let params = {order_no: item.order_no,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.$emit("refresh")
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点击收货
        onPressReceive(item) {
            this.$dialog.confirm({
                    title: '温馨提示',
                    message: '确认收到货物',
                })
                .then(() => {
                    this.receive(item);
                })
                .catch((error) => {
                    console.log('error---->', error);
                });
        },
        // 收货
        async receive(item) {
            let url = this.API.point_shop_receive_order;
            let params = {order_no: item.order_no,
            };
            let result = await this.$post(url, params);
            let that = this;
            this.Message({
                title: result.msg,
            });
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.requestData();
                this.$emit("refresh")
            }
        },
        // 点击切换支付方式
        onPressPayType(type) {
            this.payType = type
        },
        // 点击支付
        onPressPay() {
            this.showPay = !this.showPay
            // let shop_id = this.dataSources.shop_id,
            //     goods = [];
            // goods.push({
            //     name: this.dataSources.express_company,
            //     list: this.dataSources.order_detail,
            // }) 
            // this.$router.push({path: '/orderConfirm', query: {goods, shop_id}})
        },
        // 下单
        async onPressSbumit() {
            let url = this.API.point_shop_pay_order;
            let params = {order_no: this.dataSources.order_no,
                pay_type: this.payType,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.$router.go(-1)
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }
    },
};
</script>

<style lang="less" scoped>
.type {
    margin: 10px 15px 0;
    padding: 0 15px;
    height: 72px;
    display: flex;
    align-items: center;
    background-image: url('../../assets/img/img_btn_bg1.png');
    background-size: cover;

    >img {
        width: 30px;
        height: 30px;
        object-fit: contain;
        margin-right: 15px;
    }

    >div {
        flex: 1;
        display: flex;
        flex-direction: column;

        >p {
            margin-bottom: 5px;
            font-size: 15px;
            color: #fff;
        }

        >span {
            font-size: 13px;
            color: #fff;
        }
    }

    >span {
        background: #ffffff55;
        padding: 5px;
        border-radius: 3px;
        font-size: 13px;
        color: #fff;
    }

    >.arrow {
        width: 8px;
        height: 15px;
        margin-right: 0px;
    }
}

.address {
    margin: 10px 15px 0;
    padding: 15px;
    background: #fff;
    display: flex;
    align-items: center;

    img {
        width: 13px;
        height: 16px;
        object-fit: contain;
        margin-right: 15px;
    }

    div {
        overflow: hidden;
        display: flex;
        flex-direction: column;

        p {
            margin-bottom: 8px;
            font-size: 15px;
            color: #333;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            span {
                margin-left: 20px;
            }
        }

        span {
            font-size: 14px;
            color: #333;
        }
    }
}

.goods {
    margin: 10px 15px 0;
    padding: 0 10px 10px;
    background: #fff;

    >p {
        padding-top: 10px;
        font-size: 14px;
        color: #333;
    }

    >div {
        display: flex;
        margin: 10px 0 0;

        >img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            margin-right: 10px;
        }

        >div {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow: hidden;

            .title {
                font-size: 14px;
                color: #333;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }

            .unit {
                font-size: 12px;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .price {
                display: flex;
                align-items: center;

                p {
                    flex: 1;
                    font-size: 14px;
                    color: #EF1400;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                span {
                    font-size: 13px;
                    color: #333;
                    white-space: nowrap;
                }
            }
        }
    }
}

.card {
    margin: 10px 15px 0;
    padding: 0 10px;
    background: #fff;

    >div {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;

        p {
            flex: 1;
            height: 50px;
            font-size: 14px;
            color: #666666;
            line-height: 50px;
        }

        span {
            font-size: 14px;
            color: #333;
        }
    }

    .textarea {
        padding-bottom: 10px;
        flex-direction: column;
        align-items: flex-start;

        textarea {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-width: 0px;
            background: #F8F8F8;
            resize: none;
            font-size: 14px;
            color: #333;
        }
    }

    .noline {
        border-bottom: 0px;
    }
}

.footerBox {
    height: 60px;
}

.footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;

    >.service {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
            margin-bottom: 1px;
        }

        p {
            font-size: 12px;
            color: #333;
        }
    }

    >.btnBox {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        >.btn {
            margin-left: 15px;
            border-radius: 3px;
            font-size: 13px;
            text-align: center;
        }

        >.btn1 {
            width: 108px;
            height: 34px;
            border: 1px solid #7D8BEC;
            color: #7D8BEC;
            line-height: 34px;

        }

        >.btn2 {
            width: 110px;
            height: 36px;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            color: #fff;
            line-height: 36px;
        }

        >.btn3 {
            width: 231px;
            height: 36px;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            color: #fff;
            line-height: 36px;
        }
    }
}

.popup-window {
    padding: 10px 15px;

    >.item {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;

        .title {
            flex: 1;
            height: 50px;
            font-size: 15px;
            color: #333;
            text-align: center;
            line-height: 50px;
        }

        p {
            flex: 1;
            height: 50px;
            font-size: 14px;
            color: #666666;
            line-height: 50px;
        }

        img {
            width: 20px;
            height: 20px;
            object-fit: contain;
            margin-right: 10px;
        }

        >div {
            margin-left: 10px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #C8C8C8;
            display: flex;
            align-items: center;
            justify-content: center;

            >div {
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }
        }
    }

    .check {

        >div {
            border: 1px solid #7D8BEC;

            >div {
                background: #7D8BEC;
            }
        }
    }

    >.btn {
        width: 100%;
        height: 45px;
        border-radius: 3px;
        background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #fff;
    }
}
</style>
